import { d as p, L as at, M as X, k as oe, o as ot, l as st, u as lt, m as $e, A as rt, e as Se, N as Ee, f as H, i as je, q as Me, j as C } from "./country-d4e42059.js";
import * as s from "react";
import q, { memo as it, forwardRef as ct, useState as dt, useImperativeHandle as ut } from "react";
import { o as ke, P as mt, N as gt, g as Pe, e as ft, s as se } from "./index-384e14bf.js";
import { C as ht, p as ge, g as Te, m as Fe, a as T, A as pt, K as Ce, b as vt, d as Ct, u as bt, z as yt } from "./lib-1be19634.js";
import { N as xt } from "./index-6f309963.js";
import { a as wt } from "./reactNode-61f1c13f.js";
function Ie(e) {
  if (e)
    return {
      closable: e.closable,
      closeIcon: e.closeIcon
    };
}
function De(e) {
  const {
    closable: t,
    closeIcon: n
  } = e || {};
  return q.useMemo(() => {
    if (
      // If `closable`, whatever rest be should be true
      !t && (t === !1 || n === !1 || n === null)
    )
      return !1;
    if (t === void 0 && n === void 0)
      return null;
    let a = {
      closeIcon: typeof n != "boolean" && n !== null ? n : void 0
    };
    return t && typeof t == "object" && (a = Object.assign(Object.assign({}, a), t)), a;
  }, [t, n]);
}
function Re() {
  const e = {};
  for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
    n[a] = arguments[a];
  return n.forEach((o) => {
    o && Object.keys(o).forEach((l) => {
      o[l] !== void 0 && (e[l] = o[l]);
    });
  }), e;
}
const $t = {};
function St(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $t;
  const a = De(e), o = De(t), l = q.useMemo(() => Object.assign({
    closeIcon: /* @__PURE__ */ q.createElement(ht, null)
  }, n), [n]), i = q.useMemo(() => a === !1 ? !1 : a ? Re(l, o, a) : o === !1 ? !1 : o ? Re(l, o) : l.closable ? l : !1, [a, o, l]);
  return q.useMemo(() => {
    if (i === !1)
      return [!1, null];
    const {
      closeIconRender: r
    } = l, {
      closeIcon: c
    } = i;
    let u = c;
    if (u != null) {
      r && (u = r(c));
      const g = ge(i, !0);
      Object.keys(g).length && (u = /* @__PURE__ */ q.isValidElement(u) ? /* @__PURE__ */ q.cloneElement(u, g) : /* @__PURE__ */ q.createElement("span", Object.assign({}, g), u));
    }
    return [!0, u];
  }, [i, l]);
}
const kt = (e) => {
  const {
    prefixCls: t,
    className: n,
    style: a,
    size: o,
    shape: l
  } = e, i = p({
    [`${t}-lg`]: o === "large",
    [`${t}-sm`]: o === "small"
  }), r = p({
    [`${t}-circle`]: l === "circle",
    [`${t}-square`]: l === "square",
    [`${t}-round`]: l === "round"
  }), c = s.useMemo(() => typeof o == "number" ? {
    width: o,
    height: o,
    lineHeight: `${o}px`
  } : {}, [o]);
  return /* @__PURE__ */ s.createElement("span", {
    className: p(t, i, r, n),
    style: Object.assign(Object.assign({}, c), a)
  });
}, fe = kt, Nt = new at("ant-skeleton-loading", {
  "0%": {
    backgroundPosition: "100% 50%"
  },
  "100%": {
    backgroundPosition: "0 50%"
  }
}), he = (e) => ({
  height: e,
  lineHeight: X(e)
}), le = (e) => Object.assign({
  width: e
}, he(e)), Ot = (e) => ({
  background: e.skeletonLoadingBackground,
  backgroundSize: "400% 100%",
  animationName: Nt,
  animationDuration: e.skeletonLoadingMotionDuration,
  animationTimingFunction: "ease",
  animationIterationCount: "infinite"
}), be = (e, t) => Object.assign({
  width: t(e).mul(5).equal(),
  minWidth: t(e).mul(5).equal()
}, he(e)), Et = (e) => {
  const {
    skeletonAvatarCls: t,
    gradientFromColor: n,
    controlHeight: a,
    controlHeightLG: o,
    controlHeightSM: l
  } = e;
  return {
    [`${t}`]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: n
    }, le(a)),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    },
    [`${t}${t}-lg`]: Object.assign({}, le(o)),
    [`${t}${t}-sm`]: Object.assign({}, le(l))
  };
}, jt = (e) => {
  const {
    controlHeight: t,
    borderRadiusSM: n,
    skeletonInputCls: a,
    controlHeightLG: o,
    controlHeightSM: l,
    gradientFromColor: i,
    calc: r
  } = e;
  return {
    [`${a}`]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: i,
      borderRadius: n
    }, be(t, r)),
    [`${a}-lg`]: Object.assign({}, be(o, r)),
    [`${a}-sm`]: Object.assign({}, be(l, r))
  };
}, He = (e) => Object.assign({
  width: e
}, he(e)), Mt = (e) => {
  const {
    skeletonImageCls: t,
    imageSizeBase: n,
    gradientFromColor: a,
    borderRadiusSM: o,
    calc: l
  } = e;
  return {
    [`${t}`]: Object.assign(Object.assign({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "top",
      background: a,
      borderRadius: o
    }, He(l(n).mul(2).equal())), {
      [`${t}-path`]: {
        fill: "#bfbfbf"
      },
      [`${t}-svg`]: Object.assign(Object.assign({}, He(n)), {
        maxWidth: l(n).mul(4).equal(),
        maxHeight: l(n).mul(4).equal()
      }),
      [`${t}-svg${t}-svg-circle`]: {
        borderRadius: "50%"
      }
    }),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    }
  };
}, ye = (e, t, n) => {
  const {
    skeletonButtonCls: a
  } = e;
  return {
    [`${n}${a}-circle`]: {
      width: t,
      minWidth: t,
      borderRadius: "50%"
    },
    [`${n}${a}-round`]: {
      borderRadius: t
    }
  };
}, xe = (e, t) => Object.assign({
  width: t(e).mul(2).equal(),
  minWidth: t(e).mul(2).equal()
}, he(e)), Pt = (e) => {
  const {
    borderRadiusSM: t,
    skeletonButtonCls: n,
    controlHeight: a,
    controlHeightLG: o,
    controlHeightSM: l,
    gradientFromColor: i,
    calc: r
  } = e;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [`${n}`]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: i,
      borderRadius: t,
      width: r(a).mul(2).equal(),
      minWidth: r(a).mul(2).equal()
    }, xe(a, r))
  }, ye(e, a, n)), {
    [`${n}-lg`]: Object.assign({}, xe(o, r))
  }), ye(e, o, `${n}-lg`)), {
    [`${n}-sm`]: Object.assign({}, xe(l, r))
  }), ye(e, l, `${n}-sm`));
}, It = (e) => {
  const {
    componentCls: t,
    skeletonAvatarCls: n,
    skeletonTitleCls: a,
    skeletonParagraphCls: o,
    skeletonButtonCls: l,
    skeletonInputCls: i,
    skeletonImageCls: r,
    controlHeight: c,
    controlHeightLG: u,
    controlHeightSM: g,
    gradientFromColor: f,
    padding: v,
    marginSM: m,
    borderRadius: h,
    titleHeight: d,
    blockRadius: O,
    paragraphLiHeight: E,
    controlHeightXS: j,
    paragraphMarginTop: N
  } = e;
  return {
    [`${t}`]: {
      display: "table",
      width: "100%",
      [`${t}-header`]: {
        display: "table-cell",
        paddingInlineEnd: v,
        verticalAlign: "top",
        // Avatar
        [`${n}`]: Object.assign({
          display: "inline-block",
          verticalAlign: "top",
          background: f
        }, le(c)),
        [`${n}-circle`]: {
          borderRadius: "50%"
        },
        [`${n}-lg`]: Object.assign({}, le(u)),
        [`${n}-sm`]: Object.assign({}, le(g))
      },
      [`${t}-content`]: {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top",
        // Title
        [`${a}`]: {
          width: "100%",
          height: d,
          background: f,
          borderRadius: O,
          [`+ ${o}`]: {
            marginBlockStart: g
          }
        },
        // paragraph
        [`${o}`]: {
          padding: 0,
          "> li": {
            width: "100%",
            height: E,
            listStyle: "none",
            background: f,
            borderRadius: O,
            "+ li": {
              marginBlockStart: j
            }
          }
        },
        [`${o}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: "61%"
        }
      },
      [`&-round ${t}-content`]: {
        [`${a}, ${o} > li`]: {
          borderRadius: h
        }
      }
    },
    [`${t}-with-avatar ${t}-content`]: {
      // Title
      [`${a}`]: {
        marginBlockStart: m,
        [`+ ${o}`]: {
          marginBlockStart: N
        }
      }
    },
    // Skeleton element
    [`${t}${t}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: "inline-block",
      width: "auto"
    }, Pt(e)), Et(e)), jt(e)), Mt(e)),
    // Skeleton Block Button, Input
    [`${t}${t}-block`]: {
      width: "100%",
      [`${l}`]: {
        width: "100%"
      },
      [`${i}`]: {
        width: "100%"
      }
    },
    // With active animation
    [`${t}${t}-active`]: {
      [`
        ${a},
        ${o} > li,
        ${n},
        ${l},
        ${i},
        ${r}
      `]: Object.assign({}, Ot(e))
    }
  };
}, Dt = (e) => {
  const {
    colorFillContent: t,
    colorFill: n
  } = e, a = t, o = n;
  return {
    color: a,
    colorGradientEnd: o,
    gradientFromColor: a,
    gradientToColor: o,
    titleHeight: e.controlHeight / 2,
    blockRadius: e.borderRadiusSM,
    paragraphMarginTop: e.marginLG + e.marginXXS,
    paragraphLiHeight: e.controlHeight / 2
  };
}, re = Te("Skeleton", (e) => {
  const {
    componentCls: t,
    calc: n
  } = e, a = Fe(e, {
    skeletonAvatarCls: `${t}-avatar`,
    skeletonTitleCls: `${t}-title`,
    skeletonParagraphCls: `${t}-paragraph`,
    skeletonButtonCls: `${t}-button`,
    skeletonInputCls: `${t}-input`,
    skeletonImageCls: `${t}-image`,
    imageSizeBase: n(e.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${e.gradientFromColor} 25%, ${e.gradientToColor} 37%, ${e.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: "1.4s"
  });
  return [It(a)];
}, Dt, {
  deprecatedTokens: [["color", "gradientFromColor"], ["colorGradientEnd", "gradientToColor"]]
}), Rt = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: a,
    active: o,
    shape: l = "circle",
    size: i = "default"
  } = e, {
    getPrefixCls: r
  } = s.useContext(T), c = r("skeleton", t), [u, g, f] = re(c), v = ke(e, ["prefixCls", "className"]), m = p(c, `${c}-element`, {
    [`${c}-active`]: o
  }, n, a, g, f);
  return u(/* @__PURE__ */ s.createElement("div", {
    className: m
  }, /* @__PURE__ */ s.createElement(fe, Object.assign({
    prefixCls: `${c}-avatar`,
    shape: l,
    size: i
  }, v))));
}, Ht = Rt, zt = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: a,
    active: o,
    block: l = !1,
    size: i = "default"
  } = e, {
    getPrefixCls: r
  } = s.useContext(T), c = r("skeleton", t), [u, g, f] = re(c), v = ke(e, ["prefixCls"]), m = p(c, `${c}-element`, {
    [`${c}-active`]: o,
    [`${c}-block`]: l
  }, n, a, g, f);
  return u(/* @__PURE__ */ s.createElement("div", {
    className: m
  }, /* @__PURE__ */ s.createElement(fe, Object.assign({
    prefixCls: `${c}-button`,
    size: i
  }, v))));
}, Lt = zt, _t = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z", Bt = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: a,
    style: o,
    active: l
  } = e, {
    getPrefixCls: i
  } = s.useContext(T), r = i("skeleton", t), [c, u, g] = re(r), f = p(r, `${r}-element`, {
    [`${r}-active`]: l
  }, n, a, u, g);
  return c(/* @__PURE__ */ s.createElement("div", {
    className: f
  }, /* @__PURE__ */ s.createElement("div", {
    className: p(`${r}-image`, n),
    style: o
  }, /* @__PURE__ */ s.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${r}-image-svg`
  }, /* @__PURE__ */ s.createElement("path", {
    d: _t,
    className: `${r}-image-path`
  })))));
}, Tt = Bt, Ft = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: a,
    active: o,
    block: l,
    size: i = "default"
  } = e, {
    getPrefixCls: r
  } = s.useContext(T), c = r("skeleton", t), [u, g, f] = re(c), v = ke(e, ["prefixCls"]), m = p(c, `${c}-element`, {
    [`${c}-active`]: o,
    [`${c}-block`]: l
  }, n, a, g, f);
  return u(/* @__PURE__ */ s.createElement("div", {
    className: m
  }, /* @__PURE__ */ s.createElement(fe, Object.assign({
    prefixCls: `${c}-input`,
    size: i
  }, v))));
}, At = Ft;
var Vt = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 10128 0 64 64 0 10-128 0zm118-224a48 48 0 1096 0 48 48 0 10-96 0zm158 228a96 96 0 10192 0 96 96 0 10-192 0zm148-314a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "dot-chart", theme: "outlined" };
const qt = Vt;
var Wt = function(t, n) {
  return /* @__PURE__ */ s.createElement(pt, oe({}, t, {
    ref: n,
    icon: qt
  }));
}, Ae = /* @__PURE__ */ s.forwardRef(Wt);
process.env.NODE_ENV !== "production" && (Ae.displayName = "DotChartOutlined");
const Kt = Ae, Gt = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: a,
    style: o,
    active: l,
    children: i
  } = e, {
    getPrefixCls: r
  } = s.useContext(T), c = r("skeleton", t), [u, g, f] = re(c), v = p(c, `${c}-element`, {
    [`${c}-active`]: l
  }, g, n, a, f), m = i ?? /* @__PURE__ */ s.createElement(Kt, null);
  return u(/* @__PURE__ */ s.createElement("div", {
    className: v
  }, /* @__PURE__ */ s.createElement("div", {
    className: p(`${c}-image`, n),
    style: o
  }, m)));
}, Ut = Gt, Xt = (e, t) => {
  const {
    width: n,
    rows: a = 2
  } = t;
  if (Array.isArray(n))
    return n[e];
  if (a - 1 === e)
    return n;
}, Zt = (e) => {
  const {
    prefixCls: t,
    className: n,
    style: a,
    rows: o
  } = e, l = ot(Array(o)).map((i, r) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ s.createElement("li", {
      key: r,
      style: {
        width: Xt(r, e)
      }
    })
  ));
  return /* @__PURE__ */ s.createElement("ul", {
    className: p(t, n),
    style: a
  }, l);
}, Yt = Zt, Jt = (e) => {
  let {
    prefixCls: t,
    className: n,
    width: a,
    style: o
  } = e;
  return /* @__PURE__ */ s.createElement("h3", {
    className: p(t, n),
    style: Object.assign({
      width: a
    }, o)
  });
}, Qt = Jt;
function we(e) {
  return e && typeof e == "object" ? e : {};
}
function en(e, t) {
  return e && !t ? {
    size: "large",
    shape: "square"
  } : {
    size: "large",
    shape: "circle"
  };
}
function tn(e, t) {
  return !e && t ? {
    width: "38%"
  } : e && t ? {
    width: "50%"
  } : {};
}
function nn(e, t) {
  const n = {};
  return (!e || !t) && (n.width = "61%"), !e && t ? n.rows = 3 : n.rows = 2, n;
}
const Z = (e) => {
  const {
    prefixCls: t,
    loading: n,
    className: a,
    rootClassName: o,
    style: l,
    children: i,
    avatar: r = !1,
    title: c = !0,
    paragraph: u = !0,
    active: g,
    round: f
  } = e, {
    getPrefixCls: v,
    direction: m,
    skeleton: h
  } = s.useContext(T), d = v("skeleton", t), [O, E, j] = re(d);
  if (n || !("loading" in e)) {
    const N = !!r, y = !!c, b = !!u;
    let $;
    if (N) {
      const S = Object.assign(Object.assign({
        prefixCls: `${d}-avatar`
      }, en(y, b)), we(r));
      $ = /* @__PURE__ */ s.createElement("div", {
        className: `${d}-header`
      }, /* @__PURE__ */ s.createElement(fe, Object.assign({}, S)));
    }
    let D;
    if (y || b) {
      let S;
      if (y) {
        const z = Object.assign(Object.assign({
          prefixCls: `${d}-title`
        }, tn(N, b)), we(c));
        S = /* @__PURE__ */ s.createElement(Qt, Object.assign({}, z));
      }
      let P;
      if (b) {
        const z = Object.assign(Object.assign({
          prefixCls: `${d}-paragraph`
        }, nn(N, y)), we(u));
        P = /* @__PURE__ */ s.createElement(Yt, Object.assign({}, z));
      }
      D = /* @__PURE__ */ s.createElement("div", {
        className: `${d}-content`
      }, S, P);
    }
    const M = p(d, {
      [`${d}-with-avatar`]: N,
      [`${d}-active`]: g,
      [`${d}-rtl`]: m === "rtl",
      [`${d}-round`]: f
    }, h == null ? void 0 : h.className, a, o, E, j);
    return O(/* @__PURE__ */ s.createElement("div", {
      className: M,
      style: Object.assign(Object.assign({}, h == null ? void 0 : h.style), l)
    }, $, D));
  }
  return i ?? null;
};
Z.Button = Lt;
Z.Avatar = Ht;
Z.Input = At;
Z.Image = Tt;
Z.Node = Ut;
process.env.NODE_ENV !== "production" && (Z.displayName = "Skeleton");
const an = Z;
function ze() {
}
const on = /* @__PURE__ */ s.createContext({
  add: ze,
  remove: ze
});
function sn(e) {
  const t = s.useContext(on), n = s.useRef();
  return wt((o) => {
    if (o) {
      const l = e ? o.querySelector(e) : o;
      t.add(l), n.current = l;
    } else
      t.remove(n.current);
  });
}
var Le = /* @__PURE__ */ s.createContext(null), Ve = /* @__PURE__ */ s.createContext({}), ln = ["prefixCls", "className", "containerRef"], qe = function(t) {
  var n = t.prefixCls, a = t.className, o = t.containerRef, l = st(t, ln), i = s.useContext(Ve), r = i.panel, c = lt(r, o);
  return /* @__PURE__ */ s.createElement("div", oe({
    className: p("".concat(n, "-content"), a),
    role: "dialog",
    ref: c
  }, ge(t, {
    aria: !0
  }), {
    "aria-modal": "true"
  }, l));
};
process.env.NODE_ENV !== "production" && (qe.displayName = "DrawerPanel");
function _e(e) {
  return typeof e == "string" && String(Number(e)) === e ? ($e(!1, "Invalid value type of `width` or `height` which should be number type instead."), Number(e)) : e;
}
function rn(e) {
  $e(!("wrapperClassName" in e), "'wrapperClassName' is removed. Please use 'rootClassName' instead."), $e(rt() || !e.open, "Drawer with 'open' in SSR is not work since no place to createPortal. Please move to 'useEffect' instead.");
}
var Be = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none",
  position: "absolute"
};
function cn(e, t) {
  var n, a, o, l = e.prefixCls, i = e.open, r = e.placement, c = e.inline, u = e.push, g = e.forceRender, f = e.autoFocus, v = e.keyboard, m = e.classNames, h = e.rootClassName, d = e.rootStyle, O = e.zIndex, E = e.className, j = e.id, N = e.style, y = e.motion, b = e.width, $ = e.height, D = e.children, M = e.mask, S = e.maskClosable, P = e.maskMotion, z = e.maskClassName, Y = e.maskStyle, F = e.afterOpenChange, A = e.onClose, W = e.onMouseEnter, ie = e.onMouseOver, ce = e.onMouseLeave, J = e.onClick, de = e.onKeyDown, ue = e.onKeyUp, k = e.styles, L = e.drawerRender, R = s.useRef(), _ = s.useRef(), B = s.useRef();
  s.useImperativeHandle(t, function() {
    return R.current;
  });
  var V = function(I) {
    var te = I.keyCode, ne = I.shiftKey;
    switch (te) {
      case Ce.TAB: {
        if (te === Ce.TAB) {
          if (!ne && document.activeElement === B.current) {
            var ae;
            (ae = _.current) === null || ae === void 0 || ae.focus({
              preventScroll: !0
            });
          } else if (ne && document.activeElement === _.current) {
            var ve;
            (ve = B.current) === null || ve === void 0 || ve.focus({
              preventScroll: !0
            });
          }
        }
        break;
      }
      case Ce.ESC: {
        A && v && (I.stopPropagation(), A(I));
        break;
      }
    }
  };
  s.useEffect(function() {
    if (i && f) {
      var x;
      (x = R.current) === null || x === void 0 || x.focus({
        preventScroll: !0
      });
    }
  }, [i]);
  var me = s.useState(!1), Q = Se(me, 2), K = Q[0], ee = Q[1], w = s.useContext(Le), pe;
  typeof u == "boolean" ? pe = u ? {} : {
    distance: 0
  } : pe = u || {};
  var G = (n = (a = (o = pe) === null || o === void 0 ? void 0 : o.distance) !== null && a !== void 0 ? a : w == null ? void 0 : w.pushDistance) !== null && n !== void 0 ? n : 180, Je = s.useMemo(function() {
    return {
      pushDistance: G,
      push: function() {
        ee(!0);
      },
      pull: function() {
        ee(!1);
      }
    };
  }, [G]);
  s.useEffect(function() {
    if (i) {
      var x;
      w == null || (x = w.push) === null || x === void 0 || x.call(w);
    } else {
      var I;
      w == null || (I = w.pull) === null || I === void 0 || I.call(w);
    }
  }, [i]), s.useEffect(function() {
    return function() {
      var x;
      w == null || (x = w.pull) === null || x === void 0 || x.call(w);
    };
  }, []);
  var Qe = M && /* @__PURE__ */ s.createElement(Ee, oe({
    key: "mask"
  }, P, {
    visible: i
  }), function(x, I) {
    var te = x.className, ne = x.style;
    return /* @__PURE__ */ s.createElement("div", {
      className: p("".concat(l, "-mask"), te, m == null ? void 0 : m.mask, z),
      style: H(H(H({}, ne), Y), k == null ? void 0 : k.mask),
      onClick: S && i ? A : void 0,
      ref: I
    });
  }), et = typeof y == "function" ? y(r) : y, U = {};
  if (K && G)
    switch (r) {
      case "top":
        U.transform = "translateY(".concat(G, "px)");
        break;
      case "bottom":
        U.transform = "translateY(".concat(-G, "px)");
        break;
      case "left":
        U.transform = "translateX(".concat(G, "px)");
        break;
      default:
        U.transform = "translateX(".concat(-G, "px)");
        break;
    }
  r === "left" || r === "right" ? U.width = _e(b) : U.height = _e($);
  var tt = {
    onMouseEnter: W,
    onMouseOver: ie,
    onMouseLeave: ce,
    onClick: J,
    onKeyDown: de,
    onKeyUp: ue
  }, nt = /* @__PURE__ */ s.createElement(Ee, oe({
    key: "panel"
  }, et, {
    visible: i,
    forceRender: g,
    onVisibleChanged: function(I) {
      F == null || F(I);
    },
    removeOnLeave: !1,
    leavedClassName: "".concat(l, "-content-wrapper-hidden")
  }), function(x, I) {
    var te = x.className, ne = x.style, ae = /* @__PURE__ */ s.createElement(qe, oe({
      id: j,
      containerRef: I,
      prefixCls: l,
      className: p(E, m == null ? void 0 : m.content),
      style: H(H({}, N), k == null ? void 0 : k.content)
    }, ge(e, {
      aria: !0
    }), tt), D);
    return /* @__PURE__ */ s.createElement("div", oe({
      className: p("".concat(l, "-content-wrapper"), m == null ? void 0 : m.wrapper, te),
      style: H(H(H({}, U), ne), k == null ? void 0 : k.wrapper)
    }, ge(e, {
      data: !0
    })), L ? L(ae) : ae);
  }), Oe = H({}, d);
  return O && (Oe.zIndex = O), /* @__PURE__ */ s.createElement(Le.Provider, {
    value: Je
  }, /* @__PURE__ */ s.createElement("div", {
    className: p(l, "".concat(l, "-").concat(r), h, je(je({}, "".concat(l, "-open"), i), "".concat(l, "-inline"), c)),
    style: Oe,
    tabIndex: -1,
    ref: R,
    onKeyDown: V
  }, Qe, /* @__PURE__ */ s.createElement("div", {
    tabIndex: 0,
    ref: _,
    style: Be,
    "aria-hidden": "true",
    "data-sentinel": "start"
  }), nt, /* @__PURE__ */ s.createElement("div", {
    tabIndex: 0,
    ref: B,
    style: Be,
    "aria-hidden": "true",
    "data-sentinel": "end"
  })));
}
var We = /* @__PURE__ */ s.forwardRef(cn);
process.env.NODE_ENV !== "production" && (We.displayName = "DrawerPopup");
var Ke = function(t) {
  var n = t.open, a = n === void 0 ? !1 : n, o = t.prefixCls, l = o === void 0 ? "rc-drawer" : o, i = t.placement, r = i === void 0 ? "right" : i, c = t.autoFocus, u = c === void 0 ? !0 : c, g = t.keyboard, f = g === void 0 ? !0 : g, v = t.width, m = v === void 0 ? 378 : v, h = t.mask, d = h === void 0 ? !0 : h, O = t.maskClosable, E = O === void 0 ? !0 : O, j = t.getContainer, N = t.forceRender, y = t.afterOpenChange, b = t.destroyOnClose, $ = t.onMouseEnter, D = t.onMouseOver, M = t.onMouseLeave, S = t.onClick, P = t.onKeyDown, z = t.onKeyUp, Y = t.panelRef, F = s.useState(!1), A = Se(F, 2), W = A[0], ie = A[1];
  process.env.NODE_ENV !== "production" && rn(t);
  var ce = s.useState(!1), J = Se(ce, 2), de = J[0], ue = J[1];
  Me(function() {
    ue(!0);
  }, []);
  var k = de ? a : !1, L = s.useRef(), R = s.useRef();
  Me(function() {
    k && (R.current = document.activeElement);
  }, [k]);
  var _ = function(K) {
    var ee;
    if (ie(K), y == null || y(K), !K && R.current && !((ee = L.current) !== null && ee !== void 0 && ee.contains(R.current))) {
      var w;
      (w = R.current) === null || w === void 0 || w.focus({
        preventScroll: !0
      });
    }
  }, B = s.useMemo(function() {
    return {
      panel: Y
    };
  }, [Y]);
  if (!N && !W && !k && b)
    return null;
  var V = {
    onMouseEnter: $,
    onMouseOver: D,
    onMouseLeave: M,
    onClick: S,
    onKeyDown: P,
    onKeyUp: z
  }, me = H(H({}, t), {}, {
    open: k,
    prefixCls: l,
    placement: r,
    autoFocus: u,
    keyboard: f,
    width: m,
    mask: d,
    maskClosable: E,
    inline: j === !1,
    afterOpenChange: _,
    ref: L
  }, V);
  return /* @__PURE__ */ s.createElement(Ve.Provider, {
    value: B
  }, /* @__PURE__ */ s.createElement(mt, {
    open: k || N || W,
    autoDestroy: !1,
    getContainer: j,
    autoLock: d && (k || W)
  }, /* @__PURE__ */ s.createElement(We, me)));
};
process.env.NODE_ENV !== "production" && (Ke.displayName = "Drawer");
const dn = (e) => {
  var t, n;
  const {
    prefixCls: a,
    title: o,
    footer: l,
    extra: i,
    loading: r,
    onClose: c,
    headerStyle: u,
    bodyStyle: g,
    footerStyle: f,
    children: v,
    classNames: m,
    styles: h
  } = e, {
    drawer: d
  } = s.useContext(T), O = s.useCallback((b) => /* @__PURE__ */ s.createElement("button", {
    type: "button",
    onClick: c,
    "aria-label": "Close",
    className: `${a}-close`
  }, b), [c]), [E, j] = St(Ie(e), Ie(d), {
    closable: !0,
    closeIconRender: O
  }), N = s.useMemo(() => {
    var b, $;
    return !o && !E ? null : /* @__PURE__ */ s.createElement("div", {
      style: Object.assign(Object.assign(Object.assign({}, (b = d == null ? void 0 : d.styles) === null || b === void 0 ? void 0 : b.header), u), h == null ? void 0 : h.header),
      className: p(`${a}-header`, {
        [`${a}-header-close-only`]: E && !o && !i
      }, ($ = d == null ? void 0 : d.classNames) === null || $ === void 0 ? void 0 : $.header, m == null ? void 0 : m.header)
    }, /* @__PURE__ */ s.createElement("div", {
      className: `${a}-header-title`
    }, j, o && /* @__PURE__ */ s.createElement("div", {
      className: `${a}-title`
    }, o)), i && /* @__PURE__ */ s.createElement("div", {
      className: `${a}-extra`
    }, i));
  }, [E, j, i, u, a, o]), y = s.useMemo(() => {
    var b, $;
    if (!l)
      return null;
    const D = `${a}-footer`;
    return /* @__PURE__ */ s.createElement("div", {
      className: p(D, (b = d == null ? void 0 : d.classNames) === null || b === void 0 ? void 0 : b.footer, m == null ? void 0 : m.footer),
      style: Object.assign(Object.assign(Object.assign({}, ($ = d == null ? void 0 : d.styles) === null || $ === void 0 ? void 0 : $.footer), f), h == null ? void 0 : h.footer)
    }, l);
  }, [l, f, a]);
  return /* @__PURE__ */ s.createElement(s.Fragment, null, N, /* @__PURE__ */ s.createElement("div", {
    className: p(`${a}-body`, m == null ? void 0 : m.body, (t = d == null ? void 0 : d.classNames) === null || t === void 0 ? void 0 : t.body),
    style: Object.assign(Object.assign(Object.assign({}, (n = d == null ? void 0 : d.styles) === null || n === void 0 ? void 0 : n.body), g), h == null ? void 0 : h.body)
  }, r ? /* @__PURE__ */ s.createElement(an, {
    active: !0,
    title: !1,
    paragraph: {
      rows: 5
    },
    className: `${a}-body-skeleton`
  }) : v), y);
}, Ge = dn, un = (e) => {
  const t = "100%";
  return {
    left: `translateX(-${t})`,
    right: `translateX(${t})`,
    top: `translateY(-${t})`,
    bottom: `translateY(${t})`
  }[e];
}, Ue = (e, t) => ({
  "&-enter, &-appear": Object.assign(Object.assign({}, e), {
    "&-active": t
  }),
  "&-leave": Object.assign(Object.assign({}, t), {
    "&-active": e
  })
}), Xe = (e, t) => Object.assign({
  "&-enter, &-appear, &-leave": {
    "&-start": {
      transition: "none"
    },
    "&-active": {
      transition: `all ${t}`
    }
  }
}, Ue({
  opacity: e
}, {
  opacity: 1
})), mn = (e, t) => [Xe(0.7, t), Ue({
  transform: un(e)
}, {
  transform: "none"
})], gn = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n
  } = e;
  return {
    [t]: {
      // ======================== Mask ========================
      [`${t}-mask-motion`]: Xe(0, n),
      // ======================= Panel ========================
      [`${t}-panel-motion`]: ["left", "right", "top", "bottom"].reduce((a, o) => Object.assign(Object.assign({}, a), {
        [`&-${o}`]: mn(o, n)
      }), {})
    }
  };
}, fn = gn, hn = (e) => {
  const {
    borderRadiusSM: t,
    componentCls: n,
    zIndexPopup: a,
    colorBgMask: o,
    colorBgElevated: l,
    motionDurationSlow: i,
    motionDurationMid: r,
    paddingXS: c,
    padding: u,
    paddingLG: g,
    fontSizeLG: f,
    lineHeightLG: v,
    lineWidth: m,
    lineType: h,
    colorSplit: d,
    marginXS: O,
    colorIcon: E,
    colorIconHover: j,
    colorBgTextHover: N,
    colorBgTextActive: y,
    colorText: b,
    fontWeightStrong: $,
    footerPaddingBlock: D,
    footerPaddingInline: M,
    calc: S
  } = e, P = `${n}-content-wrapper`;
  return {
    [n]: {
      position: "fixed",
      inset: 0,
      zIndex: a,
      pointerEvents: "none",
      color: b,
      "&-pure": {
        position: "relative",
        background: l,
        display: "flex",
        flexDirection: "column",
        [`&${n}-left`]: {
          boxShadow: e.boxShadowDrawerLeft
        },
        [`&${n}-right`]: {
          boxShadow: e.boxShadowDrawerRight
        },
        [`&${n}-top`]: {
          boxShadow: e.boxShadowDrawerUp
        },
        [`&${n}-bottom`]: {
          boxShadow: e.boxShadowDrawerDown
        }
      },
      "&-inline": {
        position: "absolute"
      },
      // ====================== Mask ======================
      [`${n}-mask`]: {
        position: "absolute",
        inset: 0,
        zIndex: a,
        background: o,
        pointerEvents: "auto"
      },
      // ==================== Content =====================
      [P]: {
        position: "absolute",
        zIndex: a,
        maxWidth: "100vw",
        transition: `all ${i}`,
        "&-hidden": {
          display: "none"
        }
      },
      // Placement
      [`&-left > ${P}`]: {
        top: 0,
        bottom: 0,
        left: {
          _skip_check_: !0,
          value: 0
        },
        boxShadow: e.boxShadowDrawerLeft
      },
      [`&-right > ${P}`]: {
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: 0,
        boxShadow: e.boxShadowDrawerRight
      },
      [`&-top > ${P}`]: {
        top: 0,
        insetInline: 0,
        boxShadow: e.boxShadowDrawerUp
      },
      [`&-bottom > ${P}`]: {
        bottom: 0,
        insetInline: 0,
        boxShadow: e.boxShadowDrawerDown
      },
      [`${n}-content`]: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        overflow: "auto",
        background: l,
        pointerEvents: "auto"
      },
      // Header
      [`${n}-header`]: {
        display: "flex",
        flex: 0,
        alignItems: "center",
        padding: `${X(u)} ${X(g)}`,
        fontSize: f,
        lineHeight: v,
        borderBottom: `${X(m)} ${h} ${d}`,
        "&-title": {
          display: "flex",
          flex: 1,
          alignItems: "center",
          minWidth: 0,
          minHeight: 0
        }
      },
      [`${n}-extra`]: {
        flex: "none"
      },
      [`${n}-close`]: Object.assign({
        display: "inline-flex",
        width: S(f).add(c).equal(),
        height: S(f).add(c).equal(),
        borderRadius: t,
        justifyContent: "center",
        alignItems: "center",
        marginInlineEnd: O,
        color: E,
        fontWeight: $,
        fontSize: f,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        textDecoration: "none",
        background: "transparent",
        border: 0,
        cursor: "pointer",
        transition: `all ${r}`,
        textRendering: "auto",
        "&:hover": {
          color: j,
          backgroundColor: N,
          textDecoration: "none"
        },
        "&:active": {
          backgroundColor: y
        }
      }, vt(e)),
      [`${n}-title`]: {
        flex: 1,
        margin: 0,
        fontWeight: e.fontWeightStrong,
        fontSize: f,
        lineHeight: v
      },
      // Body
      [`${n}-body`]: {
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        padding: g,
        overflow: "auto",
        [`${n}-body-skeleton`]: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center"
        }
      },
      // Footer
      [`${n}-footer`]: {
        flexShrink: 0,
        padding: `${X(D)} ${X(M)}`,
        borderTop: `${X(m)} ${h} ${d}`
      },
      // ====================== RTL =======================
      "&-rtl": {
        direction: "rtl"
      }
    }
  };
}, pn = (e) => ({
  zIndexPopup: e.zIndexPopupBase,
  footerPaddingBlock: e.paddingXS,
  footerPaddingInline: e.padding
}), Ze = Te("Drawer", (e) => {
  const t = Fe(e, {});
  return [hn(t), fn(t)];
}, pn);
var Ye = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var a in e)
    Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, a = Object.getOwnPropertySymbols(e); o < a.length; o++)
      t.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (n[a[o]] = e[a[o]]);
  return n;
};
const vn = {
  distance: 180
}, Ne = (e) => {
  var t;
  const {
    rootClassName: n,
    width: a,
    height: o,
    size: l = "default",
    mask: i = !0,
    push: r = vn,
    open: c,
    afterOpenChange: u,
    onClose: g,
    prefixCls: f,
    getContainer: v,
    style: m,
    className: h,
    // Deprecated
    visible: d,
    afterVisibleChange: O,
    maskStyle: E,
    drawerStyle: j,
    contentWrapperStyle: N
  } = e, y = Ye(e, ["rootClassName", "width", "height", "size", "mask", "push", "open", "afterOpenChange", "onClose", "prefixCls", "getContainer", "style", "className", "visible", "afterVisibleChange", "maskStyle", "drawerStyle", "contentWrapperStyle"]), {
    getPopupContainer: b,
    getPrefixCls: $,
    direction: D,
    drawer: M
  } = s.useContext(T), S = $("drawer", f), [P, z, Y] = Ze(S), F = (
    // 有可能为 false，所以不能直接判断
    v === void 0 && b ? () => b(document.body) : v
  ), A = p({
    "no-mask": !i,
    [`${S}-rtl`]: D === "rtl"
  }, n, z, Y);
  if (process.env.NODE_ENV !== "production") {
    const V = Ct("Drawer");
    [["visible", "open"], ["afterVisibleChange", "afterOpenChange"], ["headerStyle", "styles.header"], ["bodyStyle", "styles.body"], ["footerStyle", "styles.footer"], ["contentWrapperStyle", "styles.wrapper"], ["maskStyle", "styles.mask"], ["drawerStyle", "styles.content"]].forEach((me) => {
      let [Q, K] = me;
      V.deprecated(!(Q in e), Q, K);
    }), F !== void 0 && ((t = e.style) === null || t === void 0 ? void 0 : t.position) === "absolute" && process.env.NODE_ENV !== "production" && V(!1, "breaking", "`style` is replaced by `rootStyle` in v5. Please check that `position: absolute` is necessary.");
  }
  const W = s.useMemo(() => a ?? (l === "large" ? 736 : 378), [a, l]), ie = s.useMemo(() => o ?? (l === "large" ? 736 : 378), [o, l]), ce = {
    motionName: Pe(S, "mask-motion"),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }, J = (V) => ({
    motionName: Pe(S, `panel-motion-${V}`),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }), de = sn(), [ue, k] = bt("Drawer", y.zIndex), {
    classNames: L = {},
    styles: R = {}
  } = y, {
    classNames: _ = {},
    styles: B = {}
  } = M || {};
  return P(/* @__PURE__ */ s.createElement(gt, null, /* @__PURE__ */ s.createElement(xt, {
    status: !0,
    override: !0
  }, /* @__PURE__ */ s.createElement(yt.Provider, {
    value: k
  }, /* @__PURE__ */ s.createElement(Ke, Object.assign({
    prefixCls: S,
    onClose: g,
    maskMotion: ce,
    motion: J
  }, y, {
    classNames: {
      mask: p(L.mask, _.mask),
      content: p(L.content, _.content),
      wrapper: p(L.wrapper, _.wrapper)
    },
    styles: {
      mask: Object.assign(Object.assign(Object.assign({}, R.mask), E), B.mask),
      content: Object.assign(Object.assign(Object.assign({}, R.content), j), B.content),
      wrapper: Object.assign(Object.assign(Object.assign({}, R.wrapper), N), B.wrapper)
    },
    open: c ?? d,
    mask: i,
    push: r,
    width: W,
    height: ie,
    style: Object.assign(Object.assign({}, M == null ? void 0 : M.style), m),
    className: p(M == null ? void 0 : M.className, h),
    rootClassName: A,
    getContainer: F,
    afterOpenChange: u ?? O,
    panelRef: de,
    zIndex: ue
  }), /* @__PURE__ */ s.createElement(Ge, Object.assign({
    prefixCls: S
  }, y, {
    onClose: g
  })))))));
}, Cn = (e) => {
  const {
    prefixCls: t,
    style: n,
    className: a,
    placement: o = "right"
  } = e, l = Ye(e, ["prefixCls", "style", "className", "placement"]), {
    getPrefixCls: i
  } = s.useContext(T), r = i("drawer", t), [c, u, g] = Ze(r), f = p(r, `${r}-pure`, `${r}-${o}`, u, g, a);
  return c(/* @__PURE__ */ s.createElement("div", {
    className: f,
    style: n
  }, /* @__PURE__ */ s.createElement(Ge, Object.assign({
    prefixCls: r
  }, l))));
};
Ne._InternalPanelDoNotUseOrYouWillBeFired = Cn;
process.env.NODE_ENV !== "production" && (Ne.displayName = "Drawer");
const bn = Ne, yn = (e) => /* @__PURE__ */ C.jsxs("svg", { width: "48", height: "19", viewBox: "0 0 48 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ C.jsx("path", { d: "M14.8529 4.73388C16.266 1.97323 18.9895 0.103516 22.0908 0.103516H38.1275C43.1711 0.103516 47.2598 4.19219 47.2598 9.23583C47.2598 14.2795 43.1711 18.3682 38.1275 18.3682H0.96875C0.96875 18.3682 5.06907 16.5719 6.70445 15.35C10.3373 12.6356 13.0874 8.18298 14.8529 4.73388Z", fill: "#FFE1D0" }),
  /* @__PURE__ */ C.jsxs("g", { filter: "url(#filter0_i_4295_131274)", children: [
    /* @__PURE__ */ C.jsx("path", { d: "M18.918 3.46191H21.2031L22.3298 10.3173L22.5043 11.7613H22.6313L23.3136 10.3173L26.9635 3.46191H29.3279L23.2025 14.824H20.9492L18.918 3.46191Z", fill: "#FF9000" }),
    /* @__PURE__ */ C.jsx("path", { d: "M30.3862 3.46191H32.5285L30.5131 14.824H28.3708L30.3862 3.46191Z", fill: "#FF9000" }),
    /* @__PURE__ */ C.jsx("path", { d: "M32.5332 14.824L34.5485 3.46191H38.357C38.8648 3.46191 39.3303 3.54126 39.7535 3.69995C40.1766 3.85864 40.5416 4.0808 40.8484 4.36644C41.1658 4.65208 41.4091 4.99591 41.5784 5.39792C41.7582 5.79993 41.8482 6.24426 41.8482 6.7309C41.8482 7.35508 41.7371 7.91049 41.5149 8.39714C41.3033 8.88378 41.0018 9.29637 40.6104 9.63491C40.219 9.96286 39.7482 10.2168 39.1981 10.3966C38.6585 10.5659 38.0661 10.6505 37.4208 10.6505H35.4054L34.6755 14.824H32.5332ZM37.7064 8.6193C38.2777 8.6193 38.7537 8.48177 39.1346 8.20671C39.5154 7.92107 39.7059 7.48203 39.7059 6.88959C39.7059 6.477 39.5789 6.14375 39.325 5.88985C39.0817 5.62537 38.722 5.49313 38.2459 5.49313H36.3258L35.7704 8.6193H37.7064Z", fill: "#FF9000" })
  ] }),
  /* @__PURE__ */ C.jsx("defs", { children: /* @__PURE__ */ C.jsxs("filter", { id: "filter0_i_4295_131274", x: "18.918", y: "3.46191", width: "22.9297", height: "12.3623", filterUnits: "userSpaceOnUse", "color-interpolation-filters": "sRGB", children: [
    /* @__PURE__ */ C.jsx("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
    /* @__PURE__ */ C.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
    /* @__PURE__ */ C.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ C.jsx("feOffset", { dy: "1" }),
    /* @__PURE__ */ C.jsx("feGaussianBlur", { stdDeviation: "0.5" }),
    /* @__PURE__ */ C.jsx("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
    /* @__PURE__ */ C.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 0.250837 0 0 0 0 0.182731 0 0 0 0.25 0" }),
    /* @__PURE__ */ C.jsx("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_4295_131274" })
  ] }) })
] }), En = it(yn);
function xn({ children: e, render: t, isModal: n = !1 }, a) {
  const [o, l] = dt(!1), i = (r) => {
    l(r);
  };
  return ut(a, () => ({
    toggleHavingTrouble(r) {
      l(!!r);
    }
  }), []), /* @__PURE__ */ C.jsx(
    ft,
    {
      overlayClassName: se.havingTroubleTip,
      title: null,
      trigger: ["click", "hover"],
      content: /* @__PURE__ */ C.jsx("div", { className: se.havingTroubleContent, style: { width: n ? "328px" : "342px" }, children: t && t() }),
      destroyTooltipOnHide: !0,
      zIndex: 1e3,
      open: o,
      onOpenChange: i,
      placement: "bottomLeft",
      children: e
    }
  );
}
const jn = ct(xn), Mn = (e) => {
  const { open: t, onClose: n, render: a } = e;
  return /* @__PURE__ */ C.jsx(
    bn,
    {
      title: null,
      placement: "bottom",
      closable: !1,
      onClose: n,
      open: t,
      zIndex: 1e5,
      rootClassName: se.havingTroubleMobile,
      children: /* @__PURE__ */ C.jsxs("div", { className: se.havingTroubleMobileMain, children: [
        /* @__PURE__ */ C.jsx("div", { className: se.havingTroubleMobileHeader, onClick: n, children: /* @__PURE__ */ C.jsx(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            children: /* @__PURE__ */ C.jsx(
              "path",
              {
                d: "M18.3646 7.05025C18.7551 6.65972 18.7551 6.02656 18.3646 5.63603C17.974 5.24551 17.3409 5.24551 16.9504 5.63603L12.0006 10.5858L7.05086 5.63603C6.66033 5.24551 6.02717 5.24551 5.63664 5.63603C5.24612 6.02656 5.24612 6.65972 5.63664 7.05025L10.5864 12L5.63664 16.9497C5.24612 17.3403 5.24612 17.9734 5.63664 18.364C6.02717 18.7545 6.66033 18.7545 7.05086 18.364L12.0006 13.4142L16.9504 18.364C17.3409 18.7545 17.974 18.7545 18.3646 18.364C18.7551 17.9734 18.7551 17.3403 18.3646 16.9497L13.4148 12L18.3646 7.05025Z",
                fill: "#B8B8B8"
              }
            )
          }
        ) }),
        /* @__PURE__ */ C.jsx("div", { className: se.havingTroubleMobileContent, children: a ? a() : null })
      ] })
    }
  );
};
export {
  jn as H,
  En as M,
  Mn as N
};
//# sourceMappingURL=index-6b21cdcf.js.map
